import { render, staticRenderFns } from "./modalProductoManual.vue?vue&type=template&id=25698a83&"
import script from "./modalProductoManual.vue?vue&type=script&lang=js&"
export * from "./modalProductoManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports